






















import { Component, Mixins } from 'vue-property-decorator';
import { Popup } from 'vant';
import Dialog from '@/mixins/Dialog';
import Box from '@/components/Box.vue';

@Component({
    components: {
        'van-popup': Popup,
        'box': Box
    }
})
export default class AnswerLateDialog extends Mixins(Dialog) {
    //继续按键
    public onContinueBtn(): void {
        this.close();
        this.$emit("continue");
    }
}
